import { render, staticRenderFns } from "./dealerDetailN.vue?vue&type=template&id=500ff90e&scoped=true"
import script from "./dealerDetailN.vue?vue&type=script&lang=js"
export * from "./dealerDetailN.vue?vue&type=script&lang=js"
import style0 from "./dealerDetailN.vue?vue&type=style&index=0&id=500ff90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500ff90e",
  null
  
)

export default component.exports